import { render, staticRenderFns } from "./ReviewOrderImport.vue?vue&type=template&id=637c357b"
import script from "./ReviewOrderImport.vue?vue&type=script&lang=js"
export * from "./ReviewOrderImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports